import ImageNotSupportedRoundedIcon from "@mui/icons-material/ImageNotSupportedRounded";
import { useTheme } from "@mui/material";
import { base } from "../styles";
import { ReactNode } from "react";
import { useI18n } from "../locales";

type Prop = {
  text?: string;
  icon?: ReactNode;
  withoutText?: boolean;
  withoutBorder?: boolean;
  height?: string;
};

/**
 * 이미지 없음 컴포넌트
 *
 */

export const NoImage = ({
  text,
  icon,
  withoutText,
  withoutBorder,
  height = "300px",
}: Prop) => {
  const { t } = useI18n();
  const theme = useTheme();
  const displayText = text || t.deviceDetail.noImage;
  return (
    <div
      style={{
        flexGrow: 1,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        gap: "10px",
        height: height,
        border: withoutBorder ? "none" : `1px solid ${theme.palette.divider}`,
        borderRadius: base.border_radius,
      }}
    >
      {icon ? icon : <ImageNotSupportedRoundedIcon />}
      {!withoutText && <span>{displayText}</span>}
    </div>
  );
};
